import React, { useEffect, useState } from "react";
import { Form, Col, Row } from "react-bootstrap";
import PropTypes from 'prop-types';
import { object, mixed } from 'yup';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { Card, Button } from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
import GetPolicyEffectiveDate  from '../../../../Helpers/Dates/GetPolicyEffectiveDate';
import { CheckboxInput } from "../../../../Helpers/Inputs";
import BackNext from '../../../Common/SubComponents/BackNext';
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem } from '../../../../../sessionStorage'
import IsJuvenile from '../../../../Helpers/Dates/IsJuvenile';
import Alert from "@material-ui/lab/Alert";

export default function Consent(props) {

  const { register, errors, handleSubmit } = useForm({
    validationSchema: Consent.ValidationSchema,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const [loading, setLoading] = useState(false);
  const [onNextFired, setOnNextFired] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  useEffect(() => {
    if (props.formState.appIdentifier) {
      props.onNext();
    }
  }, [props.formState.appIdentifier])

  const getRelationship = (id) => {

    switch (id) {
      case "20":
        return "Parent";
      case "50":
        return "Grandparent";
      case "13":
        return "Child";
      case "10":
        return "Domestic Partner";
      case "9":
        return "Spouse";
      case "18":
        return "Sibling";
      case "2":
        return "Estate of the Insured";
      default:
        return id;
    }
  }
  const onNext = () => {
    if (onNextFired) {
      return; // prevent multiple
    }
    setOnNextFired(true);
    setLoading(true);
    setShowErrorMessage(false);

    const beneficiaries = props.fullFormState.pages.beneficiaries.beneficiaries.map(bene => {
      return {
        "BeneficiaryType": bene.beneficiaryType,
        "FirstName": bene.firstName,
        "MiddleName": bene.middleInitial,
        "LastName": bene.lastName,
        "Relationship": getRelationship(bene.relationship),
        "SSN": bene.ssn,
        "Percentage": bene.percentage,
        "Address": bene.address,
        "Address2": bene.address2,
        "City": bene.city,
        "State": bene.state,
        "Zip": bene.zip,
        "Birthdate": bene.birthdate,
        "Phone": bene.phone,
        "Email": bene.email,
      }
    });

    const height = props.fullFormState.pages.basicInfo.height;
    const feet = height.split('ft')[0].trim();
    const inches = height.split('ft')[1].split('in')[0].trim();
    const totalInches = (parseInt(feet, 10) * 12) + parseInt(inches, 10);
    const Weight = props.fullFormState.pages.basicInfo.weight.split(' ')[0];

    const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;
    const isJuvenile = IsJuvenile(props.fullFormState.pages.basicInfo.birthdate);

    fetch(`${covrServicesUrl}/api/MinnSPWL/CreateInitialCase`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
      },
      body: JSON.stringify({
        "CaseInformation": {
          "General": {
            "AccountID": getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).account.oneClickAccountId,
            "CaseType": "MinnSPWL",
            "ApplicationSignatureModeType": 1,
            "DrivingRole": "ProposedInsured",
            "TrackingID": getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId,
            "JourneyType": "Consumer Self-Directed"
          },
          "Processing": {
            "CarrierID": "1650",
            "PlanName": "1Click Secure Promise Whole Life",
            "WritingAgent": {
              "FirstName": null,
              "LastName": null,
              "AppointmentNumber": null,
              "StateLicenseNumber": null
            }
          },
          "ProposedInsured": {
            "FirstName": isJuvenile ? props.fullFormState.pages.insuredInfo.childFirstName : props.fullFormState.pages.insuredInfo.firstName,
            "MiddleName": isJuvenile ? props.fullFormState.pages.insuredInfo.childMiddleName : props.fullFormState.pages.insuredInfo.middleName,
            "LastName": isJuvenile ? props.fullFormState.pages.insuredInfo.childLastName : props.fullFormState.pages.insuredInfo.lastName,
            "Address1": props.fullFormState.pages.insuredInfo.streetAddress,
            "Address2": props.fullFormState.pages.insuredInfo.apartment,
            "City": props.fullFormState.pages.insuredInfo.city,
            "State": props.fullFormState.pages.insuredInfo.state,
            "Zip": props.fullFormState.pages.insuredInfo.zip,
            "SSN": isJuvenile ? props.fullFormState.pages.insuredInfo.childSocialSecurityNumber : props.fullFormState.pages.insuredInfo.socialSecurityNumber,
            "Email": props.fullFormState.pages.insuredInfo.email,
            "Gender": props.fullFormState.pages.basicInfo.gender,
            "Birthdate": props.fullFormState.pages.basicInfo.birthdate,
            "Phone": props.fullFormState.pages.insuredInfo.phone,
            "DLNumber": props.fullFormState.pages.insuredInfo.driversLicense,
            "DLState": props.fullFormState.pages.insuredInfo.driversLicenseState,
            "DLExpiration": props.fullFormState.pages.insuredInfo.driversLicenseExpiration,
            "Height_TotalInches": totalInches,
            "UsesTobacco": props.fullFormState.pages.basicInfo.tobacco === 'true',
            "IsJuvenile": isJuvenile, // TODO future
            "PassCode": props.fullFormState.pages.insuredInfo.socialSecurityNumber.replace(/-/g, '').substring(5), // last 4 of ssn
            "Weight": Weight
          },
          "Policy": {
            "FaceAmount": props.fullFormState.pages.quoter.coverageAmount,
            "PaymentMode": 4,
            "QuotedModalPremium": props.fullFormState.pages.quoter.quotedPremium,
            "CheckPaymentAmount": 0,
            "Premium1035": 0,
            "HasOwner": isJuvenile, // If juvenile then true
          },
          "Owners": [
            isJuvenile ? {
              "FirstName": props.fullFormState.pages.insuredInfo.firstName,
              "MiddleName": props.fullFormState.pages.insuredInfo.middleName,
              "LastName": props.fullFormState.pages.insuredInfo.lastName,
              "Address1": props.fullFormState.pages.insuredInfo.streetAddress,
              "Address2": props.fullFormState.pages.insuredInfo.apartment,
              "City": props.fullFormState.pages.insuredInfo.city,
              "State": props.fullFormState.pages.insuredInfo.state,
              "Zip": props.fullFormState.pages.insuredInfo.zip,
              "SSN": props.fullFormState.pages.insuredInfo.socialSecurityNumber,
              "Email": props.fullFormState.pages.insuredInfo.email,
              "Gender": props.fullFormState.pages.insuredInfo.ownerGender,
              "Birthdate": props.fullFormState.pages.insuredInfo.ownerBirthdate,
              "Phone": props.fullFormState.pages.insuredInfo.phone,
              "MustESign": true,
              "PassCode": props.fullFormState.pages.insuredInfo.socialSecurityNumber.replace(/-/g, '').substring(5) // last 4 of ssn
            } : {}],
          "SignedState": props.fullFormState.pages.insuredInfo.state,
          "Payment": {
            "PolicyEffectiveDate": GetPolicyEffectiveDate(new Date(),14),
            "PaymentMethod": props.fullFormState.pages.payment.paymentMethod === "savings" ? 1 : 0,
            "BankName": props.fullFormState.pages.payment.bankName,
            "BankCity": props.fullFormState.pages.payment.bankCity,
            "BankState": props.fullFormState.pages.payment.bankState,
            "BankAccountNumber": props.fullFormState.pages.payment.accountNumber,
            "BankRoutingNumber": props.fullFormState.pages.payment.routingNumber,
            "PremiumPayer": "PrimaryInsured",
            "AccountHolderAddress": props.fullFormState.pages.payment.address,
            "AccountHolderAddress2": props.fullFormState.pages.payment.address2,
            "AccountHolderCity": props.fullFormState.pages.payment.city,
            "AccountHolderState": props.fullFormState.pages.payment.state,
            "AccountHolderZip": props.fullFormState.pages.payment.zip
          },
          "Beneficiaries": beneficiaries,
          "Replacement": {
            "HasExistingPolicies": isJuvenile ? props.fullFormState.pages.medicalHistory.juniorInForceInsurance : props.fullFormState.pages.medicalHistory.inForceInsurance,
            "IsReplacingExistingPolicies": isJuvenile ? props.fullFormState.pages.medicalHistory.juniorReplacement : props.fullFormState.pages.medicalHistory.replacement
          },
          "ProductData_SecurianWholeLife": {
            "AcceleratedBenefitAgreement": props.fullFormState.pages.quoter.aba,
            "AutomaticPremiumLoanProvision": props.fullFormState.pages.quoter.aplp,
            "GuaranteedInsurabilityOptionAgreement": props.fullFormState.pages.quoter.gio,
            "Felony": props.fullFormState.pages.medicalHistory.felony,
            "AIDS": props.fullFormState.pages.medicalHistory.aids,
            "AidsBloodTest": props.fullFormState.pages.medicalHistory.aids,
            "HasSeriousDisease": isJuvenile ? props.fullFormState.pages.medicalHistory.juniorSeriousDisease : props.fullFormState.pages.medicalHistory.seriousDisease,
            "HasMentalDisease": isJuvenile ? props.fullFormState.pages.medicalHistory.juniorMentalDisease : props.fullFormState.pages.medicalHistory.mentalDisease,
            "RecentlyHospitalized": isJuvenile ? props.fullFormState.pages.medicalHistory.juniorHospitalized : props.fullFormState.pages.medicalHistory.hospitalized,
            "ActiveOccupation": props.fullFormState.pages.medicalHistory.activeOccupation,
            "Under12Months": props.fullFormState.pages.medicalHistory.under12Months,
            "Premature": props.fullFormState.pages.medicalHistory.premature,
            "Juvenile13orOver": props.fullFormState.pages.medicalHistory.junior13orOver,
            "JuvenileTobaccoOrDrugs": props.fullFormState.pages.medicalHistory.juniorTobaccoOrDrugs,
            "IsLegalGuardian": props.fullFormState.pages.insuredInfo.legalGuardian,
            "Replacement_TerminateExistingPolicy": props.fullFormState.pages.medicalHistory.replacementTerminateExistingPolicy === "" ? "false" : props.fullFormState.pages.medicalHistory.replacementTerminateExistingPolicy,
            "Replacement_UsingExistingPolicyFunds": props.fullFormState.pages.medicalHistory.replacementUseExistingPolicyFunds === "" ? "false" : props.fullFormState.pages.medicalHistory.replacementUseExistingPolicyFunds
          },
          "ProductData_SecurianADI": {
            "HasAccountWithInstitutionName": false
          }
        }
      })
    })
    .then(res => {
      if (!res.ok) {
        setShowErrorMessage(true);
        setOnNextFired(false);
        return null;
      }
      return res.json();
    }).then(json => {
      if (json) {
        props.onFieldChange('appIdentifier', json.appIdentifier);
      }
    }).finally(() => {
      setLoading(false);
    });
  }

  return (
    <Row className="justify-content-center">

      <Col lg={6}>
        <form className="quote-form" onSubmit={handleSubmit(onNext)}>

          <Card className="consentCard">
            <CardContent>
              <p className="consentCardTitle">Consent To Do Business Electronically &amp; To Access Information Electronically</p>

              <p className="consentCardText">
                I agree that submitting the information requested via this web site for my insurance application, payments related thereto, or any other transaction related thereto constitutes my electronic signature for all such transactions.
                I am legally bound by electronic signatures to the same extent as if I had signed with a hand written signature.
              </p>
              <p className="consentCardText">
                I acknowledge I may withdraw my consent to the future use of my electronic signature by writing to Minnesota Life Insurance Company at 400 Robert Street North, Saint Paul, MN 55101
                or calling Minnesota Life at 1-855-750-2228 from 8:00 AM CST to 5:00 PM CST. I acknowledge that any such withdrawal will not invalidate any transaction entered into in reliance
                on my electronic signature prior to Minnesota Life’s receipt of my withdrawal.
              </p>

            </CardContent>
          </Card>

          <div className="justify-content-center">
            <Form.Group>
              <CheckboxInput
                name="agreeToTerms"
                id="agreeToTerms"
                checked={props.formState.agreeToTerms}
                onChange={e => props.onFieldChange('agreeToTerms', e.target.checked)}
                errors={errors.agreeToTerms}
                inputRef={register}
                label="I have read and agreed to these terms."
                className='mx-3'
              />
            </Form.Group>
          </div>


          <Card className="consentCard">
            <CardContent>
              <p className="consentCardTitle">USA Patriot Act Notification</p>

              <p className="consentCardText">
                The USA PATRIOT Act requires that Minnesota Life Insurance Company establish an Anti-Money Laundering (AML) Program, notify customers that we must verify the identity of the
                owner(s) of our contracts and collect information sufficient to verify identity. Failure to provide us identification information may result in the delay of issuance of coverage
                and may result in a decision not to accept your business.
              </p>
            </CardContent>
          </Card>

          <div className='mx-3'>
            <p className="currentSigner">Current Signer</p>

            <p>After clicking “I Agree”, the following party will be directed to sign the electronic application:</p>

            <p>Name: <strong>{props.fullFormState.pages.insuredInfo.firstName} {props.fullFormState.pages.insuredInfo.lastName}</strong></p>
            <p>Role: <strong>Proposed Insured</strong></p>

          </div>
          <Card className="consentCard">
            <CardContent>
              <p className="consentCardTitle">Payment Authorization</p>

              <Form.Group>
                <CheckboxInput
                  name="agreeToPaymentAuth"
                  id="agreeToPaymentAuth"
                  checked={props.formState.agreeToPaymentAuth}
                  onChange={e => props.onFieldChange('agreeToPaymentAuth', e.target.checked)}
                  errors={errors.agreeToPaymentAuth}
                  inputRef={register}
                  label="I Agree to the Following Payment Authorization:"
                />
              </Form.Group>

              <p className="consentCardTitle">ELECTRONIC FUNDS TRANSFER ACCOUNT HOLDER AUTHORIZATIONS</p>

              <p className="consentCardText">
                I hereby authorize Minnesota Life Insurance Company to take deductions each month from the checking or savings account with the financial institution as indicated on this application. I understand and agree that this authorization is
                subject to the following conditions:
              </p>

              <p className="consentCardText">
                The amount of the deduction will be equal to the scheduled premium due for my insurance coverage as shown on the policy data pages.
              </p>

              <p className="consentCardText">
                I will receive notice of each electronic debit entry that varies in the amount from the previous entry.
              </p>

              <p className="consentCardText">
                This authorization is to remain in full effect until Minnesota Life has received and has had reasonable time to act on the authorized account holder’s request to cancel in writing at 400 Robert Street North, Saint Paul, MN 55101 or by
                telephone at 1-877-282-1930 from 8:00 AM CST to 5:00 PM CST.
              </p>

            </CardContent>
          </Card>

          {showErrorMessage && (
            <div className="pt-3 pb-3">
              <Alert severity="error">An error occurred trying to submit your case.</Alert>
            </div>
          )}

          <div className="pt-3">
            <BackNext onBack={props.onBack} disabled={loading} loading={loading} />
          </div>

          {!loading && (
            <Row className="pb-5 justify-content-center">
              <Button disabled={loading} className="btn-wide-sm" href="/DidNotConsent">I DO NOT AGREE</Button>
            </Row>
          )}
        </form>

      </Col>

    </Row>
  )
}

Consent.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
}

Consent.ValidationSchema = object().shape({
  agreeToTerms: mixed().oneOf([true], 'You must agree to the terms.'),
  agreeToPaymentAuth: mixed().oneOf([true], 'You must agree to the payment authorization.'),
})

Consent.DefaultFormState = (prefill = false) => {
  return {
    agreeToTerms: prefill ? true : false,
    agreeToPaymentAuth: prefill ? true : false,
    appIdentifier: null,
  }
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Securian/WL/steps/Consent.js